module.exports = new __parcel__URL__("item_shop_tab_active.4bd7be42.png").toString();